// Angular
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
// Afidium
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';
import { SmsBreadcrumbService } from '../../services/sms-breadcrumb.service';
import { formGroupConfig, getValidators } from './config/form';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { WORDING } from './config/wording';
import { ProcessingSmsService } from '../../services/processing-sms.service';
import { IVariableEntry } from 'libraries/model/IVariableEntry';
import { SmsTextGenerationService } from 'libraries/service/resources/sms-text-generation/sms-text-generation.service';
import { ILabels } from 'libraries/interfaces/ILabels';
import { TitleService } from 'app_sasha/shared/services/title/title.service';
import { Yii } from 'libraries/interfaces/Yii';
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";

@Component({
    selector: 'processing-sms-form',
    template: `
    <div class="app-wrapper app-sasha">
        <breadcrumb [items]="breadcrumbItems"></breadcrumb>

        <card>
            <div class="card-header-content">
                <h1>{{ wording.header }}</h1>

                <div>
                    <back-button></back-button>

                    <btnForm styleType="actionDo" (click)="previousView()">
                        {{ wording.previousStep }}
                    </btnForm>
                    <btnForm styleType="actionPrincipal" (click)="goToValidationView()">
                        {{ wording.nextStep }}
                    </btnForm>
                </div>
            </div>
            <div class="card-body-content card-padding-inside">
                <form *ngIf="fieldConfig" novalidate>
                    <simple-textarea-field-with-variables
                        [fieldConfig]="fieldConfig.body"
                        [variablesConfig]="{ canUseVariables: true, help: variableConfig }"
                    ></simple-textarea-field-with-variables>
                </form>
            </div>
        </card>
    </div>
    `,
    styles: [`
        simple-textarea-field-with-variables ::ng-deep textarea {
            max-width: 350px;
            min-height: 350px;
            min-width: 350px;
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProcessingSmsFormComponent implements OnInit {
    public breadcrumbItems: IBreadcrumbItem[] = [];
    public form: FormGroup;
    public wording: ILabels = WORDING;
    public modelName: string;
    public variableConfig: IVariableEntry;
    public fieldConfig: {
        body: IFieldSpecs;
    };

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly smsBreadcrumbService: SmsBreadcrumbService,
        private readonly processingSmsService: ProcessingSmsService,
        private readonly smsTextGenerationService: SmsTextGenerationService,
        private readonly router: Router,
        private readonly titleService: TitleService,
        private readonly errorTracingService: ErrorTracingService,
    ) { }

    public ngOnInit(): void {
        this.breadcrumbItems = this.smsBreadcrumbService.breadcrumbForm();
        this.titleService.setTitle(Yii.t("wui-sasha-js", "Rédaction d'un SMS"));

        this.form = formGroupConfig(this.formBuilder);

        this.fieldConfig = {
            body: this.getFieldConfig('body')
        };

        this.variableConfig = this.smsTextGenerationService.getHelpModel();

        if (this.processingSmsService.form) {
            this.modelName = this.processingSmsService.form.name;
            this.patchTemplateValuesInForm(this.processingSmsService.form);
        }
    }

    public previousView(): void {
        this.router.navigate(['/sasha/processing-sms'], {
    queryParamsHandling: 'preserve'
}).catch((reason: boolean) => { this.errorTracingService.captureException(reason); });
    }

    public patchTemplateValuesInForm(smsTemplate): void {
        this.form.patchValue({
            body: smsTemplate.parameter ? smsTemplate.parameter.body : smsTemplate.body,
            stopClause: smsTemplate.parameter ? smsTemplate.parameter.stopClause : smsTemplate.stopClause,
        });
    }

    public goToValidationView(): void {
        if (this.form.valid) {
            this.processingSmsService.form = {
                ...this.form.value,
                ...{ modelName: this.modelName }
            };
            this.router.navigate(['/sasha/processing-sms/validation'], {
    queryParamsHandling: 'preserve'
}).catch((reason: boolean) => { this.errorTracingService.captureException(reason); });
        } else {
            Object.entries(this.form.controls)
                .forEach(([key, control]: [string, FormControl]) => {
                    control.markAsTouched();
                });
        }
    }

    private getFieldConfig(formControlName: string): IFieldSpecs {
        return {
            formGroup: this.form,
            label: WORDING[formControlName],
            formControlName,
            validators: getValidators(formControlName)
        };
    }
}
